import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "input", "error", "template"]
  static values = { maxVideoBytes: Number, existingVideoBytes: Number, sizeError: String }

  initialize() {
    this.previewUrls = []
  }

  disconnect() {
    this.clearPreview()
  }

  choose() {
    this.inputTarget.click()
  }

  preview() {
    this.clearPreview()
    if (this.hasErrorTarget) this.errorTarget.hidden = true
    const files = Array.from(this.inputTarget.files)
    const videoBytes = files.filter(file => file.type.startsWith("video/")).reduce((sum, file) => sum + file.size, this.existingVideoBytesValue)

    if (this.hasMaxVideoBytesValue && videoBytes > this.maxVideoBytesValue) {
      this.inputTarget.value = ""
      this.errorTarget.textContent = this.sizeErrorValue
      this.errorTarget.hidden = false
      return
    }

    files.forEach((file, index) => {
      const video = file.type.startsWith("video/")
      const preview = document.createElement(video ? "video" : "img")
      const url = URL.createObjectURL(file)
      this.previewUrls.push(url)
      preview.src = url
      if (video) {
        preview.controls = true
        preview.playsInline = true
        preview.preload = "metadata"
        preview.className = "mw-100 rounded"
        preview.setAttribute("aria-label", file.name)
      } else {
        preview.alt = file.name
      }
      if (this.hasTemplateTarget) {
        const item = this.templateTarget.content.cloneNode(true)
        item.querySelector("[data-media-preview-file]").appendChild(preview)
        const button = item.querySelector("button")
        button.dataset.index = index
        button.setAttribute("aria-label", `${button.textContent.trim()}: ${file.name}`)
        this.containerTarget.appendChild(item)
      } else {
        this.containerTarget.appendChild(preview)
      }
    })
  }

  remove(event) {
    const files = new DataTransfer()
    const removedIndex = Number(event.currentTarget.dataset.index)
    Array.from(this.inputTarget.files).forEach((file, index) => {
      if (index !== removedIndex) files.items.add(file)
    })
    this.inputTarget.files = files.files
    this.inputTarget.dispatchEvent(new Event("change", {bubbles: true}))
    this.element.querySelector('[data-action="media-preview#choose"]').focus()
  }

  clearPreview() {
    this.previewUrls.forEach(url => URL.revokeObjectURL(url))
    this.previewUrls = []
    this.containerTarget.replaceChildren()
  }
}
